import {
  toPredictionPointBaseFilters as buildPredictionPointBaseFilters,
  toPredictionPointFilters as buildPredictionPointFilters,
  PredictionPointApiBaseFilters,
  PredictionPointFilters,
  UiPredictionPointBaseFilters,
  UiPredictionPointFilters,
} from "portal/utils/categoryCollection/predictionPoints";
import {
  getRadiusFilterUnits,
  radiusUnitsToMm,
} from "portal/utils/categoryCollection/radius";
import { PageSortParams } from "protos/portal/veselka";
import { useCallback } from "react";
import { useSelf } from "portal/state/store";

export const useToPredictionPointFilters = (
  scopeCustomerUuid?: string
): {
  toPredictionPointFilters: (
    filters: UiPredictionPointFilters,
    pagination: PageSortParams
  ) => PredictionPointFilters;
  toPredictionPointBaseFilters: (
    filters: UiPredictionPointFilters
  ) => PredictionPointApiBaseFilters;
} => {
  const { measurementSystem } = useSelf();

  const buildRadiusFilter = useCallback(
    (
      radiusUserUnits: UiPredictionPointBaseFilters["radiusUserUnits"]
    ): { radiusMin?: number; radiusMax?: number } => {
      const radiusFilterUnits = getRadiusFilterUnits(measurementSystem);
      if (
        radiusUserUnits !== undefined &&
        (radiusUserUnits[0] !== undefined || radiusUserUnits[1] !== undefined)
      ) {
        const [minMm, maxMm] = radiusUserUnits.map((r) =>
          r === undefined ? undefined : radiusUnitsToMm(r, radiusFilterUnits)
        );
        return {
          radiusMin: minMm,
          radiusMax: maxMm,
        };
      }
      return {
        radiusMin: undefined,
        radiusMax: undefined,
      };
    },
    [measurementSystem]
  );

  const toPredictionPointFilters = useCallback(
    (
      filters: UiPredictionPointFilters,
      pagination: PageSortParams
    ): PredictionPointFilters => {
      const { radiusMin, radiusMax } = buildRadiusFilter(
        filters.radiusUserUnits
      );
      return buildPredictionPointFilters(
        pagination,
        filters,
        radiusMin,
        radiusMax,
        scopeCustomerUuid
      );
    },
    [scopeCustomerUuid, buildRadiusFilter]
  );

  const toPredictionPointBaseFilters = useCallback(
    (filters: UiPredictionPointFilters): PredictionPointApiBaseFilters => {
      const { radiusMin, radiusMax } = buildRadiusFilter(
        filters.radiusUserUnits
      );
      return buildPredictionPointBaseFilters(
        filters,
        radiusMin,
        radiusMax,
        scopeCustomerUuid
      );
    },
    [buildRadiusFilter, scopeCustomerUuid]
  );

  return {
    toPredictionPointFilters,
    toPredictionPointBaseFilters,
  };
};
